// extracted by mini-css-extract-plugin
export default {"col":"YssDA9obqfrIiHJ4Put1","row":"_zq0gW2XarmL4lQjL6LQ"};